import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { ErrorBoundaryComponent } from "./Modules/Error/ErrorBoundary/ErrorBoundary";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet, ErrorBoundaryComponent],
  templateUrl: "./App.html",
  styleUrl: "./App.scss",
})
export class App {}
